import React from 'react';
import ReactDOM from 'react-dom';
import { WhiteLabelThemeProvider } from 'app/WhiteLabelThemeProvider';
import { useSelector } from 'react-redux';
import { selectWhitelabelConfigFromBootstrap } from 'store/slice/bootstrap';

interface PortalProps {
    children: React.ReactNode;
    container?: Element;
}

const Portal: React.FC<PortalProps> = (props: PortalProps) => {
    const { children: childrenProp, container = document.body } = props;
    const whitelabelConfig = useSelector(selectWhitelabelConfigFromBootstrap);

    const el = React.useRef(document.createElement('div'));

    React.useEffect(() => {
        const current = el.current;
        container.appendChild(current);
        return () => {
            container.removeChild(current);
        };
    }, [container]);

    const children = <WhiteLabelThemeProvider whiteLabelId={whitelabelConfig.whiteLabelId}>{childrenProp}</WhiteLabelThemeProvider>;

    return ReactDOM.createPortal(children, el.current);
};

Portal.displayName = 'Portal';
export default Portal;
